<div class="modal-header">
    <div>
        <h4 class="modal-title" translate>{{title}}</h4>
    </div>
    <span (click)="modalRef.hide()" class="ml-auto cursor-pointer close-btn">
        <i class="far fa-xmark" aria-hidden="true"></i>
    </span>
</div>
<div class="modal-body cs-common-ui">
    <div class="cs-d-flex h-100" *ngIf="!isLoading; else: loader">
        <ng-container *ngIf="viewMode=='form'">
            <app-sidebar-nav
                (updatedActiveItem)="setCurrentActiveItem($event)"
                [navService]="sidebarNavService">
            </app-sidebar-nav>
            <div class="cs-flex-1 h-100 cs-common-ui--fs-box-inset-shadow pos-rlt">
                <div class="cs--fs-body-shadow"></div>
                <ng-container *ngIf="currentActiveMenuItem">
                    <app-basic-details-step
                        [sidebarNavService]="sidebarNavService"
                        [screenName]="screenName"
                        [objectName]="objectName"
                        [settingsTypeId]="settingsTypeId"
                        [closeFullScreenModal]="closeModal.bind(this)"
                        [workflowData]="workflowData"
                        [isDraftMode]="isDraftMode"
                        *ngIf="currentActiveMenuItem.id === 'basic_details'">
                    </app-basic-details-step>

                    <app-automation-step
                        [metaData]="metadata"
                        [settingsTypeId]="settingsTypeId"
                        [screenName]="screenName"
                        [objectName]="objectName"
                        [workflowData]="workflowData"
                        [sidebarNavService]="sidebarNavService"
                        [isDraftMode]="isDraftMode"
                        [closeFullScreenModal]="closeModal.bind(this)"
                        *ngIf="currentActiveMenuItem.id === 'custom_automation'">
                    </app-automation-step>
                </ng-container>
            </div>
        </ng-container>

        <app-automation-audit
            [metaData]="metadata"
            [settingsTypeId]="settingsTypeId"
            [workflowData]="workflowData"
            [screenName]="screenName"
            [dagRunId]="undefined"
            *ngIf="viewMode=='audit'" class="cs-flex-full">
        </app-automation-audit>
    </div>
</div>

<ng-template #loader>
    <div class="cs-d-flex align-items-center justify-center h-100">
        <div class="spreadsheet-loading-wrap">
            <span class="loading-spreadsheet">
                <span class="loading-x-axis"></span>
                <span class="loading-y-axis"></span>
                <ng-container *ngFor="let number of [0]">
                    <div class="loading-row row-1"></div>
                    <div class="loading-row row-2"></div>
                    <div class="loading-row row-3"></div>
                    <div class="loading-row row-1"></div>
                    <div class="loading-row row-2"></div>
                </ng-container>
            </span>
        </div>
    </div>
</ng-template>

